import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import './MainPage.css';

const INTERNAL = [
  { to: '/crear', fallbackImg: '/crear.png', configKey: 'cardCrear', icon: 'fa-solid fa-hammer',       title: 'Construir Mazo', description: 'Arma tu mazo con cartas de cada edición.' },
  { to: '/meta',  fallbackImg: '/meta.png',  configKey: 'cardMeta',  icon: 'fa-solid fa-ranking-star', title: 'Meta',           description: 'Consulta los enfrentamientos y analiza el meta actual del juego.' },
];

const EXTERNAL = [
  { href: 'https://datosyleyendas.com/',        fallbackImg: '/articulos.png', configKey: 'cardArticulos', icon: 'fa-solid fa-newspaper',         title: 'Artículos', description: 'Lee artículos sobre estrategia, torneos y novedades.' },
  { href: 'https://datosyleyendas.com/elo-myl', fallbackImg: '/elo.png',       configKey: 'cardElo',       icon: 'fa-solid fa-arrow-up-right-dots', title: 'ELO-MyL',   description: 'Consulta el ranking ELO de los mejores jugadores.' },
];

function MainPage() {
  const [imgConfig, setImgConfig] = useState({});

  useEffect(() => {
    getDoc(doc(db, 'config', 'images')).then((snap) => {
      if (snap.exists()) setImgConfig(snap.data());
    });
  }, []);

  const winratesUrl = imgConfig.mainWinrates || '/merged_images.png';

  return (
    <div className="MainPage">
      <Navbar />
      <div className="hero-section">
        <h1 className="hero-title">Bienvenido a <span className="hero-brand">ElMeta.cl</span></h1>
        <p className="hero-subtitle">Tu plataforma de referencia para Mitos y Leyendas</p>
      </div>
      <main className="main-hero">
        <div className="main-layout">
          <div className="cards-column">
            {INTERNAL.map(({ to, fallbackImg, configKey, icon, title, description }) => {
              const img = imgConfig[configKey] || fallbackImg;
              return (
                <Link
                  key={to}
                  to={to}
                  className="feature-card"
                  style={{ backgroundImage: `linear-gradient(rgba(15,5,10,0.55), rgba(15,5,10,0.55)), url('${img}')` }}
                >
                  <i className={icon} />
                  <h2>{title}</h2>
                  <p>{description}</p>
                </Link>
              );
            })}
            {EXTERNAL.map(({ href, fallbackImg, configKey, icon, title, description }) => {
              const img = imgConfig[configKey] || fallbackImg;
              return (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="feature-card"
                  style={{ backgroundImage: `linear-gradient(rgba(15,5,10,0.55), rgba(15,5,10,0.55)), url('${img}')` }}
                >
                  <i className={icon} />
                  <h2>{title}</h2>
                  <p>{description}</p>
                </a>
              );
            })}
          </div>

          <div className="snapshot-column">
            <Link to="/meta" className="meta-snapshot-img-wrap">
              <img src={winratesUrl} alt="Winrates actuales" className="meta-snapshot-img" />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default MainPage;
